import React from 'react'

import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'
import { usePageParams } from 'src/utils/params'
import InfoCard from 'src/ui/InfoCard/InfoCard'

import NextActivitySkeleton from './NextActivitySkeleton'
import welcomeCard from './assets/welcome_card.svg'

const NextActivityWelcome = () => {
  const { l2Code } = usePageParams()

  return (
    <NextActivitySkeleton
      headerSection={t('Start here')}
      contentSection={
        <InfoCard
          title={t('Welcome to C-level Learning!')}
          description={t(
            'You’ve mastered the basics, now you have the choice on what you want to learn!'
          )}
          imgUrl={welcomeCard}
          aspectRatio="16:9"
          actionText={t('Create my course')}
          actionUrl={routes.advanced_my_course(l2Code)}
        />
      }
    />
  )
}

NextActivityWelcome.propTypes = {}

export default NextActivityWelcome
